import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  EventEmitter,
  Output,
  QueryList,
} from '@angular/core';
import { TabComponent } from '../tab/tab.component';
@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class TabsComponent implements AfterContentInit {
  @ContentChildren(TabComponent) tabs!: QueryList<TabComponent>;
  @Output() tabSelected = new EventEmitter<number>();

  activeTab?: TabComponent;

  ngAfterContentInit(): void {
    this.setInitialActiveTab();
  }

  selectTab(selectedTab: TabComponent) {
    this.activeTab = selectedTab;
    this.tabs.toArray().forEach((tab: TabComponent) => {
      tab.toggleActive(tab === this.activeTab);
    });
    const activeTabIndex = this.tabs
      .toArray()
      .findIndex((tab) => tab === selectedTab);
    this.tabSelected.emit(activeTabIndex);
  }

  private setInitialActiveTab(): void {
    this.activeTab = this.tabs.find((tab) => tab.active()) ?? this.tabs.first;
    this.selectTab(this.activeTab);
  }
}
